<template>
    <b-table :fields="fields" :items="items" hover no-border-collapse striped stacked="md">
        <template #empty>
            <span>Não foram encontrados dados.</span>
        </template>
        <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
        </template>
        <template #table-busy>
            <div class="text-center text-dark">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="loading-text">Carregando...</strong>
            </div>
        </template>
        <template v-slot:cell(status)="row">
            <font-awesome-icon v-if="row.item.actions.isSaved" class="text-success" icon="check" />
            <span v-else>Pendente</span>
        </template>
        <template v-slot:cell(pathSugerido)="row">
            <span v-if="row.item.actions.isSugerivel">Sim</span>
            <span v-else>Não</span>
        </template>
        <template v-slot:cell(actions)="row">
            <acoes-arquivo-cell v-if="row.item.actions.isSaved" :item="row.item" :canRemove="false"
                :key="row.item.codArquivo" :newIdPrestacaoConta="newIdPrestacaoConta" :ro="true" />
            <span v-else>-</span>
        </template>
    </b-table>
</template>

<script>
import AcoesArquivoCell from '@/components/pca/AcoesArquivoCell.vue'
import { fieldsArquivosPCA } from '@/types/entregas/pca/fields-arquivos-pca'

export default {
    components: { AcoesArquivoCell },
    data() {
        return {
            fields: fieldsArquivosPCA,
        }
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
        newIdPrestacaoConta: {
            type: Number,
            required: true
        }
    }
}
</script>

<style></style>